// Começa na segunda página pois a primeira carrega pelo laravel
let page = 2;
let sortDirection = null;
let sortBy = null;
// Loader para o mobile
let isFetching = false;
const isMobile = window.innerWidth <= 800;
let resetListeners = true;

/**
 * Inicializando o js da tela de aprovacoes
 */
function init() {
  // Aplica os listeners para o scroll infinito
  applyInfinityScroll();
  // Reseta o scroll da página quando entra nela
  window.scrollTo(0, 0);
  // Reseta o valor da página caso mude o filtro
  $('#approvals-filters input,select').on('change', () => {
    page = 2;
    applyInfinityScroll();
  })

  // Aplica os listeners para os filtros da tabela
  applySortByListeners();
}

/**
 * Executa quando dar scroll
 */
function onScroll(){
  if (isFetching) {return;}

  const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);

  // Se for desktop pegamos 45% do tamanho do scroll como parametro se for mobile 25%
  // de terminar o scroll chamamos a função.
  const fromBottom = !isMobile ? (documentHeight - viewportHeight) * 0.45 : (documentHeight - viewportHeight) * 0.25;

  const minScrollPosition = documentHeight - viewportHeight;

  if (scrollPosition + fromBottom >= minScrollPosition) {
    requestNewReports();
  }
}

/**
 * Aplica os listeners de scroll
 */
function applyInfinityScroll(){
  //Infinite Scroll
  if (resetListeners) {
    $(window).on('scroll', onScroll);
    $(window).on('touchmove', onScroll);
    resetListeners = false;
  }
}


/**
 * Cria o elemento da table de aprovações e os elementos mobiles
 */
function addNewReports(relatorios){
  const mobileItems = $(relatorios).find('.mobile-grid__item');
  const tableRows = $(relatorios).find('tbody tr');

  tableRows.hide().appendTo('#reports-table tbody').fadeIn(400);
  mobileItems.hide().appendTo('.mobile-grid').fadeIn(400);
  $('[data-toggle="tooltip"]').tooltip();
}

/**
 * Busca novos relatórios para aprovação
 */
function requestNewReports(isSortingTable){
  const loader = $('.approvals-loader');
  const sort = sortBy ? '&' + $.param({ 'sort_by': sortBy}) : '';
  const direction = sortDirection ? '&' + $.param({ 'sort_direction': sortDirection}) : '';

  isFetching = true;

  if (!isSortingTable) {
    loader.show();
  }

  $.ajax({
    type: 'GET',
    url: `${route('app.aprovacoes.index')}?${$.param({ 'page': page })}${sort}${direction}`,
  }).then((response) => {
    const { data } = response;
    // Desabilita os listeners caso não tenha mais itens
    if (!data) {
      $(window).off('scroll');
      $(window).off('touchmove');
      resetListeners = true;
      // Adiciona os novos itens na pagina
    } else {

      if (isSortingTable) {
        $('.mobile-grid .mobile-grid__item').fadeOut(100).remove();
        $('#reports-table').find('tbody tr').fadeOut(100).remove();
        nifty.body.overlay('hide');
      }

      addNewReports(data);
      page++;
    }
    isFetching = false;
    loader.hide();
  })
}

/**
 * Aplica os listeners dos filtros do datatable
 */
function applySortByListeners(){
  const table = $('#reports-table');
  table.find('thead tr th').off('click').on('click', onSortTable);
  table.find('thead tr th').off('selectstart');
  table.find('thead tr th').off('keypress');
}


/**
 * Aplica os listeners dos filtros do datatable
 */
function onSortTable(){
  if (isFetching) { return; }

  const table = $('#reports-table');
  const sort_by = $(this).data('sort');
  const sort_dir = $(this).attr('class').split('_')[1];
  const users = $('[name="users[]"]').val();
  const status = $('[name="status[]"]').val();

  sortBy = sort_by || null;
  page = 1;

  table.find(`thead tr th:not([data-sort='${sort_by}'], [class="sorting"], [data-orderable='false'])`).removeClass('sorting_asc sorting_desc').addClass('sorting');

  if (!sort_dir || sort_dir === 'desc') {

    $(this).removeClass('sorting');
    $(this).removeClass('sorting_desc');
    $(this).addClass('sorting_asc');
    sortDirection = 'asc';

  } else if (sort_dir === 'asc') {

    $(this).removeClass('sorting_asc');
    $(this).addClass('sorting_desc');
    sortDirection = 'desc';

  }

  if ((sort_by === 'status' && status.length == 1) || (sort_by === 'nomeUsuario' && users.length == 1)) { return; }

  if (resetListeners) {
    applyInfinityScroll();
  }

  nifty.body.overlay({fixed: true});
  nifty.body.overlay('show');

  requestNewReports(true);
}

module.exports = {
  init: init,
  applySortByListeners: applySortByListeners,
  url: /\/aprovacoes/,
}
